import React, {useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectEvent} from 'helpers/hooks/utils';
import StyledCollectionCategoriesSectionPanelContent
  from 'components/organisms/SectionPanels/CollectionCategoriesSectionPanelContent/CollectionCategoriesSectionPanelContent.styles';
import DndContext from 'components/organisms/Utils/DragDrop/DndContext';
import useMediaQuery from '@mui/material/useMediaQuery';
import CollectionSectionPanelHeader
  from 'components/organisms/SectionPanels/CollectionSectionPanelHeader/CollectionSectionPanelHeader';
import CollectionProfile from 'components/organisms/Profiles/CollectionProfile/CollectionProfile';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';

const info = 'Add and manage categories for your collection company profiles';

const CollectionCategoriesSectionPanelContent = React.forwardRef((props, ref) => {
  const {
    section,
    collection,
    isLoading,
    onCanUpdate,
    ...innerProps
  } = useComponentProps(props, 'CollectionCategoriesSectionPanelContent');

  const innerRef = useRef(null);

  useImperativeHandle(ref, () => innerRef.current);

  const profileProvider = useProfile();
  const setSettingsEvent = useEffectEvent(profileProvider.setSettings);
  const onboarding = profileProvider?.state?.settings?.onboarding;

  const handleShowCard = (card) => {
    return card.name.startsWith('tagGroup');
  };

  const handleCardClose = () => {
    if (onboarding) {
      setSettingsEvent?.({onboarding: false});
    }
  }

  const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return <StyledCollectionCategoriesSectionPanelContent ref={innerRef} {...innerProps}>
    <CollectionSectionPanelHeader title={section.title} info={!smDown ? info : null}/>
    <DndContext>
      <CollectionProfile columns={smDown ? 1 : 2}
                         variant="grid"
                         sortable={true}
                         dragHandle={true}
                         forceEditNew={onboarding}
                         onCloseCard={handleCardClose}
                         onShowCard={handleShowCard}/>
    </DndContext>
  </StyledCollectionCategoriesSectionPanelContent>
});

CollectionCategoriesSectionPanelContent.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  section: PropTypes.object,
  collection: PropTypes.object,
  isLoading: PropTypes.bool,
  onCanUpdate: PropTypes.func
};

export default CollectionCategoriesSectionPanelContent;
